export const APP_VERSION = 'unknown';
export const APP_COMMIT = '2d6cd54';
